<div class="overflow-y-auto h-[85vh] mx-5 mb-5 pr-5 mr-0 overflow-x-hidden font-poppins">
	<div class="bg-white rounded-2xl ">
		<span class="join gap-2 relative w-full">
			<app-dashboard-page-header [platformName]="'instagram'"  (selectedDateRange)="updateStats($event)" [hasNoPages]="instagramPageIds.length==0 && !isInsightsLoading" />
			
		</span>
	</div>
	<div class=" bg-white my-5 py-2 rounded-xl p-5">
		<h3 class="font-bold py-4 text-xl block" [ngClass]="{'animate-pulse':isInsightsLoading}">{{'pageInsights.labels.general'|translate}}</h3>
		<div class="flex flext-wrap gap-2 w-[100%] pb-3" >
			<app-widget-stats *ngFor="let item of GetGeneralData()" class=" w-[25%] " [data]="item" [source]="'instagram'" [isLoading]="isInsightsLoading" />
		</div>
	</div>
	<div class=" bg-white my-5 py-2 rounded-xl p-5">
		<h3 class="font-bold py-4 text-xl block" [ngClass]="{'animate-pulse':isInsightsLoading}">{{'pageInsights.labels.audience'|translate}}</h3>
		<div class="flex flext-wrap gap-2 w-[100%] pb-3" >
			<app-widget-stats *ngFor="let item of GetAudienceData()" class=" w-[25%] " [data]="item" [source]="'instagram'" [isLoading]="isInsightsLoading" />
		</div>
	</div>
	<div class=" bg-white my-5 py-2 rounded-xl p-5">
		<h3 class="font-bold py-4 text-xl block" [ngClass]="{'animate-pulse':isInsightsLoading}">{{'pageInsights.labels.profile'|translate}}</h3>
		<div class="flex flext-wrap gap-2 w-[100%] pb-3" >
			<app-widget-stats *ngFor="let item of GetProfileData()" class=" w-[25%] " [data]="item" [source]="'instagram'" [isLoading]="isInsightsLoading" />
		</div>
	</div>

	<div class=" bg-white my-5 py-2 rounded-xl p-5">
		<h3 class="font-bold py-4 text-xl block" [ngClass]="{'animate-pulse':isInsightsLoading}">{{'pageInsights.labels.views'|translate}}</h3>
		<div class="flex flext-wrap gap-2 w-[100%] pb-3" >
			<app-widget-stats *ngFor="let item of GetViewsDate()" class=" w-[25%] " [data]="item" [source]="'instagram'" [isLoading]="isInsightsLoading" />
		</div>
	</div>

	<!-- delete this part -->
	 <div *ngIf="instagramPageIds.length>0" class="bg-white h-[82vh] my-5 py-5 relative flex items-end rounded-2xl">
		 <div class="rounded-2xl h-[80vh] overflow-hidden absolute w-full">
			 <app-posts-library  [dashboard]="true" [dashboardSource]="'instagram'" [currentPostsTypeFilter]="{isPosted:true,isPlanned:true}" [dateRange]="period" [currentPlaTformsFilters]= "{isFacebookON: false, isLinkedinON: false, isGoogleON: false, isInstagramON: true}"/>
		 </div>
	 </div>
	<!-- end delete -->
</div>
  
  